export default "__VITE_PUBLIC_ASSET__fb6f513d__"